import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import './ServiceAreas.css';

const areas = [
  { name: "Spring, TX", desc: "Our home base — 20923 Holzwarth Road, 77388", primary: true },
  { name: "Klein, TX", desc: "Minutes away via FM 2920" },
  { name: "The Woodlands, TX", desc: "Convenient access south via I-45" },
  { name: "Tomball, TX", desc: "Easy drive via the Tomball Tollway" },
  { name: "Humble, TX", desc: "Serving Humble and Atascocita" },
  { name: "Cypress, TX", desc: "Northwest Houston collision repair" },
  { name: "North Houston, TX", desc: "Full service for greater north Houston" }
];

const ServiceAreas = () => (
  <section id="service-areas" className="service-areas section">
    <div className="container">
      <div className="service-areas__header">
        <h2 className="service-areas__title">Areas We Serve</h2>
        <p className="service-areas__subtitle">
          Axis Collision Center provides auto body repair and collision services across the greater Spring, TX area
        </p>
      </div>
      <div className="service-areas__grid">
        {areas.map((area, i) => (
          <div key={i} className={`service-areas__card ${area.primary ? 'service-areas__card--primary' : ''}`}>
            <FiMapPin className="service-areas__icon" />
            <h3 className="service-areas__name">{area.name}</h3>
            <p className="service-areas__desc">{area.desc}</p>
          </div>
        ))}
      </div>
      <div className="service-areas__cta">
        <p>Need collision repair? We offer <strong>towing services</strong> to our facility from all service areas.</p>
        <a href="tel:+18326156065" className="btn btn--primary">
          Call (832) 615-6065
        </a>
      </div>
    </div>
  </section>
);

export default ServiceAreas;
